export default function(){
    return(
        <div className="widget info-widget"><h2>Cliquez sur la carte pour indiquer votre position</h2></div>
    )
}